/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboStructsFindingApps
 */
export interface JumboStructsFindingApps {
    /**
     * 
     * @type {string}
     * @memberof JumboStructsFindingApps
     */
    appId?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsFindingApps
     */
    appName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof JumboStructsFindingApps
     */
    isVerified?: boolean;
}

/**
 * Check if a given object implements the JumboStructsFindingApps interface.
 */
export function instanceOfJumboStructsFindingApps(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboStructsFindingAppsFromJSON(json: any): JumboStructsFindingApps {
    return JumboStructsFindingAppsFromJSONTyped(json, false);
}

export function JumboStructsFindingAppsFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboStructsFindingApps {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'appId': !exists(json, 'appId') ? undefined : json['appId'],
        'appName': !exists(json, 'appName') ? undefined : json['appName'],
        'isVerified': !exists(json, 'isVerified') ? undefined : json['isVerified'],
    };
}

export function JumboStructsFindingAppsToJSON(value?: JumboStructsFindingApps | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'appId': value.appId,
        'appName': value.appName,
        'isVerified': value.isVerified,
    };
}

